import { postRequest } from '@/helpers/request';

// eslint-disable-next-line import/prefer-default-export
export async function apiSetTutorialViewed(contentId) {
  const response = await postRequest('/library/api/view_library_tutorial_for_content', { id: contentId });
  return response;
}
